import { FC, useCallback } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { DialogStatus, TPayout } from '@src/types';
import {
  CompletePayoutRequest,
  ApprovePayoutRequest,
} from '@features/admin/payoutRequests';

interface PayoutRequestDialogProps {
  open: boolean;
  refreshData?: () => Promise<void>;
  onOpenChange: (open: boolean) => void;
  status?: DialogStatus;
  item?: TPayout;
}
export const PayoutRequestDialog: FC<PayoutRequestDialogProps> = ({
  open,
  refreshData,
  onOpenChange,
  status = DialogStatus.Request,
  item,
}) => {
  const renderContent = useCallback(() => {
    switch (status) {
      case DialogStatus.Request:
        return (
          <CompletePayoutRequest
            item={item}
            refreshData={refreshData}
            onOpenChange={onOpenChange}
          />
        );
      case DialogStatus.Approve:
        return (
          <ApprovePayoutRequest
            item={item}
            refreshData={refreshData}
            onOpenChange={onOpenChange}
          />
        );
      default:
        return <></>;
    }
  }, [item, onOpenChange, status, refreshData]);

  return (
    <Dialog.Root open={open}>
      <Dialog.Portal>
        <Dialog.Overlay
          className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80"
          data-slot="sheet-overlay"
        />
        <Dialog.Content className="fixed left-1/2 top-1/2 max-h-[85vh] lg:w-[918px] w-[80%] -translate-x-1/2 -translate-y-1/2 rounded-[20px] bg-[#414141] pt-[38px] pb-[79px] px-[44px] shadow-[var(--shadow-6)] focus:outline-none data-[state=open]:animate-contentShow z-50 overflow-auto">
          {renderContent()}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
